import { List } from 'immutable';
import { defaultMemoize } from 'reselect';

import { isResourceLoading } from './common';

const isStatesLoading = defaultMemoize(isResourceLoading);
const getStates = defaultMemoize(
    (data) => data.getIn(['states'], List()),
);

export {
    isStatesLoading,
    getStates,
};
